import {
  MainContainer,
  Avatar,
  ChatContainer,
  Message,
  MessageList,
  MessageInput,
  TypingIndicator,
} from '@chatscope/chat-ui-kit-react';
import { Box, Button, Grid, Snackbar, SnackbarContent, useMediaQuery } from '@mui/material';
import { variants } from '../../../../variants/variants';
import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectBotTyping,
  selectDisableInput,
  selectDraftForm,
  selectFullScreen,
  selectIsStarted,
  selectMessages,
  selectShowDraftMessage,
  selectShowMyHistory,
  selectUsingDraft,
  sendIncomingMessage,
  sendOutgoingMessage,
  setDraftForm,
  setReason,
} from '../../giftSlice';
import { createMessage } from '../../utility/createMessage';
import { useCheckEligibilityQuery, useDeleteFormMutation, useGetMyFormsQuery } from '../../giftApiSlice';
import PendingGift from './PendingGift';
import { CloseRounded } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Typography } from '@mui/material';
import { Stack } from '@mui/material';
import { ChatSkeleton } from '../common/GiftSkeleton';
import SwipeEdge from '../../../../common/SwipeEdge';

export const Chat = ({ lg = 8 }) => {
  const { isLoading: checkLoading } = useCheckEligibilityQuery();
  const { isLoading: formsLoading } = useGetMyFormsQuery();
  const dispatch = useDispatch();
  const [input, setInput] = useState('');
  const messages = useSelector(selectMessages);
  const botTyping = useSelector(selectBotTyping);
  const disableInput = useSelector(selectDisableInput);
  const isStarted = useSelector(selectIsStarted);
  const showDraftMessage = useSelector(selectShowDraftMessage);
  const draftForm = useSelector(selectDraftForm);
  const usingDraft = useSelector(selectUsingDraft);
  const [deleteDraft] = useDeleteFormMutation();
  const fullScreen = useSelector(selectFullScreen);
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'));
  const inputRef = useRef(null);
  const handleInputChange = (_, value) => {
    setInput(value);
  };

  const handleStart = () => {
    dispatch(sendIncomingMessage({}));
  };
  const handleSend = () => {
    let value = input;
    const outgoing = createMessage(value, { select: false, type: 'outgoing' });
    setInput('');
    dispatch(sendOutgoingMessage({ message: outgoing }));
    dispatch(setReason({ reason: value }));
    dispatch(sendIncomingMessage({}));
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    deleteDraft(draftForm._id);
  };
  const handleUseDraft = () => {
    dispatch(setDraftForm());
  };
  const action = (
    <Button size='small' variant='contained' sx={{ mx: 'auto' }} onClick={handleUseDraft}>
      use draft
    </Button>
  );
  if (checkLoading || formsLoading) {
    return <ChatSkeleton />;
  }
  return (
    <Grid item xs={12} lg={lg} sx={{height:"100%"}}>
      
      <MainContainer responsive style={{ borderRadius: variants.boxRadius.MAIN, position: 'relative' }}>
        <SnackbarContent
          message={
            <Stack direction='row'>
              <Typography component={'span'} sx={{ mr: 'auto' }}>
                You have a saved draft, do you want to use that instead?
              </Typography>
              <IconButton size='small' color='inherit' onClick={handleClose}>
                <CloseRounded fontSize='small' />
              </IconButton>
            </Stack>
          }
          action={action}
          sx={{
            display: showDraftMessage ? 'block' : 'none',
            position: 'absolute',
            zIndex: 1300,
            top: 0,
            right: 0,
            left: 0,
            p: 2,
            pt: 0,
            background: 'white',
            color: variants.typography.active.main,
            fontWeight: 600,
          }}
        />
        <ChatContainer
          style={{ paddingTop: '1rem', height: fullScreen ? '91vh' : `calc(100vh - 130px)` }}
        >
          {/* {isMobile && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                p: 1,
                borderBottom: 1,
                borderColor: 'black',
                background: variants.boxBackground.NAVBAR,
                // borderRadius: variants.boxRadius.NAVBAR,
                alignItems: 'center',
              }}
            ><div></div></Box>
          )} */}
          <MessageList
            style={{ paddingBottom: '1rem' }}
            typingIndicator={
              <TypingIndicator content='GIFT bot is typing' style={{ display: botTyping ? 'flex' : 'none' }} />
            }
          >
            {messages?.map((m, index) => {
              return m.startButton ? (
                !isStarted && (
                  <Message key={index} className={m.type} model={m.model}>
                    <Avatar
                      className='chatAvatar'
                      name='Emily'
                      src='https://chatscope.io/storybook/react/assets/emily-xzL8sDL2.svg'
                    />
                    <Message.CustomContent>
                      <Button variant='contained' size='small' onClick={handleStart}>
                        {usingDraft ? 'Continue' : 'Start'}
                      </Button>
                    </Message.CustomContent>
                  </Message>
                )
              ) : (
                <Message key={index} className={m.fullWidth ? `${m.type} full-width` : m.type} model={m.model}>
                  {m.avatar && (
                    <Avatar
                      size='md'
                      className='chatAvatar'
                      name='GIFT bot'
                      src='https://chatscope.io/storybook/react/assets/emily-xzL8sDL2.svg'
                    />
                  )}
                  <Message.CustomContent>{m.content}</Message.CustomContent>
                </Message>
              );
            })}
            <PendingGift />
          </MessageList>

          <MessageInput
            autoFocus
            ref={inputRef}
            disabled={disableInput}
            placeholder='Type message here'
            onChange={handleInputChange}
            onSend={handleSend}
            value={input}
            attachButton={false}
          />
        </ChatContainer>
      </MainContainer>
    </Grid>
  );
};
